import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const ArrowIcon = (props: IIconProps) => {
  const { width = 7, height = 6, color = 'currentColor' } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 7 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.50007 6L5.24537e-07 -1.35122e-07L7 4.76837e-07L3.50007 6Z"
        fill={color}
      />
    </svg>
  );
};

export default memo(ArrowIcon);
